import React from "react";

const Loader: React.FC = () => {

  return (
    // <div className="" style={{width: "auto", minHeight: "auto", background: "#e5e5e5", zIndex: 1000 }}>
      <div className="spinner-border text-primary" style={{"width": "3rem", "height": "3rem"}} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    // </div>
  );
};

export default Loader;

